import React from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { IconCopy } from '@tabler/icons'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { View, Text } from 'styles/reactnative'
import { useDepositStore } from '../../../../hooks/deposit/store'
import { useFetcher } from '../../../../hooks/fetcher'

const DepositWalletAddress = () => {
	const { t } = useTranslation()

	const { data: depositStore } = useDepositStore({
		network: 'TRC20',
		coin: 'USDT',
	})

	const { data: res } = useFetcher(
		`/user/my/wallet?coin=${depositStore?.coin}&network=${depositStore?.network}`
	)

	const walletAddress = res?.result?.result?.wallet_address || ''

	const handleCopyClick = () => {
		toast(`${t('copiedSuccessfully')}`)
		navigator.clipboard.writeText(walletAddress)
	}

	return (
		<View
			style={{
				width: '100%',
				alignItems: 'flex-start',
				justifyContent: 'flex-start',
			}}>
			<Text>
				{depositStore?.coin} {t('walletAddress')}
			</Text>
			<View
				style={{
					flexDirection: 'row',
					justifyContent: 'space-between',
					border: `1px solid ${COLORS.secondary}`,
					width: '100%',
					borderRadius: 5,
					marginTop: 10,
				}}>
				<View
					style={{
						width: '88%',
						alignItems: 'flex-start',
						paddingInline: 10,
						paddingBlock: 15,
					}}>
					<Text size={12} style={{ color: COLORS.secondary }}>
						{walletAddress}
					</Text>
				</View>
				<CButton
					onClick={handleCopyClick}
					icon={<IconCopy />}
					style={{
						width: '12%',
						height: '100%',
						paddingBlock: 10,
						background: COLORS.white,
					}}
				/>
			</View>
		</View>
	)
}

export default DepositWalletAddress
